// Small formatting helpers shared by the UI templates.

export const fmtMoney = (n: number): string =>
  '$' + Math.round(n).toLocaleString('en-AU');

export const fmtMoney0 = fmtMoney;

export const fmtKwh = (n: number): string =>
  Math.round(n).toLocaleString('en-AU') + ' kWh';

export const fmtKw = (n: number): string => `${n} kW`;

export const fmtYears = (n: number | null): string =>
  n == null ? 'No payback' : `${n} yr`;

/** Verbose form for the hero card, e.g. "3.8 years". */
export const fmtYearsLong = (n: number | null): string =>
  n == null ? 'No payback' : `${n} year${n === 1 ? '' : 's'}`;

export const fmtPct = (frac: number): string => `${Math.round(frac * 100)}%`;

/** Escape a string for safe interpolation into HTML attribute/text content. */
export function esc(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
